import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the WeatherEventsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-daily-leg-load-events',
  templateUrl: 'daily-leg-load-events.html',
})
export class DailyLegLoadEventsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-events/daily-leg-load-events.ts